import React from 'react';
import { useTranslation } from 'react-i18next';

import DashboardCard from '../../Layout/DashboardCard';
import TableDataParse from './TableDataParse';

function VirtualAnalyzerFrequentFile(props: { data: any; day: string }) {
  const { t } = useTranslation();
  return (
    <DashboardCard
      title={t('dashboard.chart.title.virtualAnalyzerFrequentFile')}
    >
      <TableDataParse
        data={props.data}
        type="FILE"
        day={props.day}
        timeFormat={t('common.momentDateFormat')}
      />
    </DashboardCard>
  );
}

export default React.memo(VirtualAnalyzerFrequentFile);
